<template>
  <div v-loading="isLoading">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="container mb10 mt10"
    >
      <el-breadcrumb-item :to="{ path: '/qbank' }">题库中心</el-breadcrumb-item>
      <el-breadcrumb-item>题库练习</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="start container mb20" v-if="detail">
      <div class="ohide">
        <div class="BGwhite pad30 gray1 flex radius8 mb20">
          <div class="top-left">
            <img src="@/assets/img/home/42.png" alt="" />
          </div>
          <div class="top-center flex1">
            <p class="name mb5">{{ detail.ExerciseName }}</p>
            <p class="content">
              <span># {{ detail.ClassifyName }}</span>
              <span>题量：{{ detail.TotalNum }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="topic-box BGwhite pad30 radius8">
        <h2>做题模式</h2>
        <div class="select-box">
          <div class="flex">
            <div
              class="item"
              @click="EModType = 1"
              :class="EModType == 1 ? 'active' : ''"
            >
              <span>顺序练习</span>
            </div>
            <div
              class="item"
              @click="EModType = 2"
              :class="EModType == 2 ? 'active' : ''"
            >
              <span>随机练习</span>
            </div>
            <div
              class="item"
              @click="EModType = 3"
              :class="EModType == 3 ? 'active' : ''"
            >
              <span>背题模式</span>
            </div>
          </div>
        </div>
        <h2 class="mt50">题目类型</h2>
        <div class="select-box">
          <div class="flex">
            <div
              class="item"
              @click="changeEQType(0)"
              :class="EQType == 0 ? 'active' : ''"
            >
              <span>全部</span>
            </div>
            <div
              class="item"
              @click="changeEQType(1)"
              :class="EQType == 1 ? 'active' : ''"
            >
              <span>单选题</span>
            </div>
            <div
              class="item"
              @click="changeEQType(2)"
              :class="EQType == 2 ? 'active' : ''"
            >
              <span>多选题</span>
            </div>
            <div
              class="item"
              @click="changeEQType(3)"
              :class="EQType == 3 ? 'active' : ''"
            >
              <span>判断题</span>
            </div>
            <div
              v-show="EModType == 3"
              class="item"
              @click="changeEQType(4)"
              :class="EQType == 4 ? 'active' : ''"
            >
              <span>主观题</span>
            </div>
          </div>
        </div>
        <h2 class="mt50">出题数量：{{ QuesNum }}</h2>
        <div class="my-slider">
          <el-slider
            v-model="QuesNum"
            :min="0"
            :max="TotalNum"
            class="pdl6"
          ></el-slider>
          <p class="showTip">
            <span>0</span>
            <span>{{ TotalNum }}</span>
          </p>
        </div>
        <div class="btn-box mt50">
          <el-button type="primary" class="btn" @click="toExercise"
            >开始练习</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Exercise_GetDetail, Exercise_Create } from "@/api/exam";
export default {
  name: "ExerciseCreate",
  data() {
    return {
      TotalNum: 0,
      detail: {},
      EModType: 1, //1:顺序模式 2:随机模式 3:背题模式
      EQType: 0,
      QuesNum: 0,
    };
  },

  components: {},
  watch: {
    "$route.query.ExerciseID"(newValue) {
      if (newValue) {
        this.getDetail();
      }
    },
  },
  created() {
    this.getDetail();
  },

  methods: {
    changeEQType(val) {
      this.EQType = val;
      if (val == 0) {
        this.TotalNum = this.detail.TotalNum;

      } else if (val == 1) {
        this.TotalNum = this.detail.DanNum;
      } else if (val == 2) {
        this.TotalNum = this.detail.DuoNum;
      } else if (val == 3) {
        this.TotalNum = this.detail.PanNum;
      } else if (val == 4) {
        this.TotalNum = this.detail.ZhuNum;
      }
      this.QuesNum = this.TotalNum;

    },
    toExercise() {
      const data = {
        ExerciseID: this.$route.query.ExerciseID,
        EModType: this.EModType,
        EQType: this.EQType,
        QuesNum: this.QuesNum,
      };
      Exercise_Create(data).then((res) => {
        this.$router.push({
          path: "/exam/exercises",
          query: {
            UEID: res.data.UEID,
            ExerciseID: this.$route.query.ExerciseID,
          },
        });
      });
    },
    getDetail() {
      Exercise_GetDetail({
        ExerciseID: this.$route.query.ExerciseID,
      }).then((res) => {
        if (res.data) {
          this.detail = { ...this.detail, ...res.data };
          this.TotalNum = this.detail.TotalNum;
          this.QuesNum =this.detail.TotalNum;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dtTitle {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 24px;
    left: 0;
    width: 6px;
    height: 20px;
    background: #1d79ff;
    border-radius: 3px;
  }
}
.red {
  background: #ffe6e8;
  border-radius: 4px;
  text-align: center;
  color: #eb525c;
  width: 57px;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #eb525c;
    color: white;
  }
}
.container {
  .top-left {
    width: 70px;
    height: 70px;
    margin-right: 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .top-center {
    .name {
      font-weight: bold;
      font-size: 24px;
      color: #333333;
    }
    .content {
      font-size: 18px;
      color: #666666;
      span {
        margin-right: 50px;
      }
    }
  }
  .top-right {
    .daojishi {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .hand {
      width: 144px;
      height: 52px;
      background: #1d79ff;
      border-radius: 6px;
      font-size: 18px;
    }
  }
  .topic-box {
    padding: 100px 230px 200px 250px;
    h2 {
      font-size: 20px;
      color: #333333;
      margin-bottom: 20px;
    }
    .btn-box {
      text-align: center;
      .btn {
        width: 144px;
        height: 52px;
        margin: 0 auto;
        background: #1d79ff;
        border-radius: 6px;
        font-size: 18px;
      }
    }
    .select-box {
      .flex {
        gap: 20px;
        .item {
          cursor: pointer;
          width: 240px;
          height: 52px;
          font-size: 18px;
          line-height: 52px;
          text-align: center;
          color: #666666;
          background: #eef2f6;
          border-radius: 8px;
          img {
            width: 26px;
            height: 26px;
            margin-right: 10px;
          }
          &:hover {
            color: #2979fb;
            background: #e1edff;
            border: 1px solid #1477ff;

            position: relative;
            &::after {
              content: "";
              position: absolute;
              right: -1px;
              bottom: -2px;
              width: 33px;
              height: 19px;
              border-radius: 10px 0px 6px 0px;
              background: url("../../assets/img/home/40.png") no-repeat center;
              background-size: 32px 18px;
            }
          }
        }
        .active {
          color: #2979fb;
          background: #e1edff;
          border: 1px solid #1477ff;

          position: relative;
          &::after {
            content: "";
            position: absolute;
            right: -1px;
            bottom: -2px;
            width: 33px;
            height: 19px;
            border-radius: 10px 0px 6px 0px;
            background: url("../../assets/img/home/40.png") no-repeat center;
            background-size: 32px 18px;
          }
        }
      }
    }
  }
  .my-slider {
    ::v-deep .el-slider__runway {
      // 滑块的进度条颜色
      background-color: #eef2f6;
      .el-slider__bar {
        background-color: #1477ff;
      }
    }

    ::v-deep .el-slider__button {
      // 拖动的滑块的样式
      width: 60px;
      height: 30px;
      border-radius: 0;
      border: none;
      background: url("../../assets/img/home/60.png") no-repeat center;
      background-size: 60px 30px;
      &:hover {
        transform: scale(1.01);
      }
      &.dragging {
        transform: scale(1.01);
      }
    }
    .pdl6 {
      padding-left: 8px;
    }
    .showTip {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-weight: bold;
        font-size: 20px;
        color: #1d79ff;
        line-height: 26px;
      }
    }
  }
}
</style>
